import CryptoJS from 'crypto-js';

export const handleEncrypt = (dataToEncrypt:string) => {
    const secretKey = process.env.REACT_APP_E_KEY as string;
      var utf8SecretKey = CryptoJS.enc.Utf8.parse(secretKey);
      var utf8DataToEncrypt = CryptoJS.enc.Utf8.parse(dataToEncrypt);
      // Encrypt
      const encrypted = CryptoJS.AES.encrypt(utf8DataToEncrypt, utf8SecretKey,{
        mode: CryptoJS.mode.ECB ,padding: CryptoJS.pad.Pkcs7,
      }).toString();
      //end
    return encrypted;
};

export const encryptJson=(json:any)=> {
  const encryptedJson = handleEncrypt(JSON.stringify(json));
  return encryptedJson;
}

export const encryptJsonKeyValue=(json:any)=> {
    const encryptedJson:any = {};
    for (const [key, value] of Object.entries(json)) {
      const encryptedKey = handleEncrypt(key);
      const encryptedValue = handleEncrypt(value as string);

      encryptedJson[encryptedKey] = encryptedValue;
    }
  
    return encryptedJson;
}


export const handleDecrypt = (dataToDecrypt:string) => {
    const secretKey = process.env.REACT_APP_E_KEY as string
    var utf8SecretKey = CryptoJS.enc.Utf8.parse(secretKey);

    const decrypted = CryptoJS.AES.decrypt(dataToDecrypt, utf8SecretKey, {
      mode: CryptoJS.mode.ECB ,padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8);
    return decrypted;
};

export const decryptJson=(json:any)=> {
  const decryptedJson = handleDecrypt(json);
  return JSON.parse(decryptedJson);
}

export const isRawOrderId = (value?: string): boolean =>
  !!value &&
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(value);

export const decryptOrderIdIfEncrypted = (value?: string): string | undefined => {
  if (!value) return value;
  if (isRawOrderId(value)) return value;
  try {
    const decrypted = handleDecrypt(value);
    return decrypted || value;
  } catch {
    return value;
  }
};

export const decryptJsonKeyValue=(json:any)=> {
    const decryptedJson:any = {};
    for (const [key, value] of Object.entries(json)) {
      const decryptedKey = handleDecrypt(key);
      const decryptedValue = handleDecrypt(value as string);
      decryptedJson[decryptedKey] = decryptedValue;
    }
  
    return decryptedJson;
  }


  //for Routing

  export const handleUrlParamEncrypt = (dataToEncrypt:string) => {
    const secretKey = process.env.REACT_APP_E_KEY as string;
      var utf8SecretKey = CryptoJS.enc.Utf8.parse(secretKey);
      var utf8DataToEncrypt = CryptoJS.enc.Utf8.parse(dataToEncrypt);

      const encrypted = CryptoJS.AES.encrypt(utf8DataToEncrypt, utf8SecretKey,{
        mode: CryptoJS.mode.ECB ,padding: CryptoJS.pad.Pkcs7,
      });
      
      const encryptedBase64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encrypted.toString()));
    return encryptedBase64;
};


export const handleUrlParamDecrypt = (dataToDecrypt:string) => {
  const secretKey = process.env.REACT_APP_E_KEY as string
  var utf8SecretKey = CryptoJS.enc.Utf8.parse(secretKey);
  const decodedData = CryptoJS.enc.Base64.parse(dataToDecrypt).toString(CryptoJS.enc.Utf8);;

  const decrypted = CryptoJS.AES.decrypt(decodedData, utf8SecretKey, {
    mode: CryptoJS.mode.ECB ,padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);  
  return decryptedText;
};
export const isEncryptedParam = (value: string) => {
  try {
    // Try to Base64 decode first
    const decoded = CryptoJS.enc.Base64.parse(value).toString(CryptoJS.enc.Utf8);

    // Try AES decrypt using your existing logic
    const secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_E_KEY as string);
    const decrypted = CryptoJS.AES.decrypt(decoded, secretKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    const text = decrypted.toString(CryptoJS.enc.Utf8);

    // If decryption produced a non-empty result, it's encrypted
    return !!text;
  } catch (e) {
    return false;
  }
};

export const getActualOrderId = (paramOrderId: string) => {
  if (isEncryptedParam(paramOrderId)) {
    return handleUrlParamDecrypt(paramOrderId);
  } else {
    return paramOrderId;
  }
};

export const setFavicon = (iconUrl: string) => {
  if (!iconUrl) return;

  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.type = /\.svg(\?|$)/i.test(iconUrl) ? "image/svg+xml" : "image/png";
  link.href = iconUrl;
};